import Box from '@mui/joy/Box';
import Link from "@mui/joy/ListItem";
import Stack from '@mui/joy/Stack';
import Typography from "@mui/joy/Typography";
import { Grid } from '@mui/joy';

import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import PhoneIcon from '@mui/icons-material/Phone';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InstagramIcon from '@mui/icons-material/Instagram';


import './styles/footer.css'
import GiveModal from './GiveModal';

const Footer = () => {
    return (
        <Box className='footer'>
                             <Grid container justifyContent='center' textAlign='center' sx={{marginTop: 2, marginBottom: 2}}>
                                <Box sx={{minWidth: 200}}>
                                    <Stack direction='column' alignItems='center'>
                                        <PhoneIcon sx={{color: '#006494', marginBottom: .75}} fontSize='large' />
                                        <Typography level='title-lg'>Call Us</Typography>
                                        <Typography level='body-lg' textAlign='center'><a className='footerLink' href='tel:9724757511'>(972) 475-7511</a></Typography>
                                    </Stack>
                                </Box>
                                <Box sx={{minWidth: 200, marginLeft: 3, marginRight: 3}}>
                                <Stack direction='column' alignItems='center'>
                                    <FmdGoodIcon sx={{color: '#006494',marginBottom: .75}} fontSize='large'/>
                                    <Typography level='title-lg'>Find Us</Typography>
                                    <a className='footerLink' href='https://maps.app.goo.gl/aptJc46XDx7rMGwG7' target='_blank' rel="noopener noreferrer">
                                        <Typography level='body-lg' textAlign='center'>4301 Dalrock Road</Typography>
                                        <Typography level='body-lg' textAlign='center'>Rowlett, TX 75088</Typography>
                                    </a>
                                </Stack>
                                </Box>
                                <Box sx={{minWidth: 200}}>
                                    <Stack direction='column' alignItems='center'>
                                        <EmailIcon sx={{color: '#006494', marginBottom: .75}} fontSize='large'/>
                                        <Typography level='title-lg'>Email Us</Typography>
                                        <Typography level='body-lg' textAlign='center'><a className='footerLink' href='mailto:contactNHV@gmail.com'>contactNHV@gmail.com</a></Typography>
                                    </Stack>
                                </Box>
                            </Grid>
                        <Stack direction='row' spacing={2} justifyContent='center' sx={{marginTop: 3}}>
                            <a className='footer-facebook' href='https://www.facebook.com/NewHorizonVineyard/'><FacebookIcon fontSize='large'/></a>
                            <a className='footer-youtube' href='https://www.youtube.com/@newhorizonvineyardchurch4635'><YouTubeIcon fontSize='large'/></a>
                            <a className='footer-instagram' href='https://www.instagram.com/nhvineyard/'><InstagramIcon fontSize='large'/></a>
                        </Stack>
                        <Stack direction='row' spacing={4} justifyContent='center'  sx={{marginTop: 1.2, marginBottom: 1.2}}>
                            <Link>
                                <a className='footerLinkBottom' href="/">Home</a>
                            </Link>
                            <Link>
                                <a className='footerLinkBottom' href="join">Plan A Visit</a>
                            </Link>
                            <Link variant='plain'>
                                <GiveModal linkClass="footerLinkBottom" text="Give"/>
                                {/* need to style the link for give modal */}
                            </Link>
                        </Stack>

            <Box className='footer-copyright'>
                <Typography level='body-md'>
                    Copyright 2025 New Horizon Vineyard Church
                </Typography>
                <Typography level='body-sm'>
                    Powered by Olympus Code LLC
                </Typography>
            </Box>
        </Box>
    );
}

export default Footer
